import './styles.scss'
import React from 'react'
import SudokuLayout from './sudoku'
import MediaLayout from './media'
import JustTextLayout from './just-text'
import BlogLayout from './blog'

// 我们的团队
const articlesCollection = (props) => {
  const defaultCustomize = {
    _type: 'articles-collection',
    collection: 'all',
    per: 20,
  }
  
  //
  return [{
    uid: 'collection-articles-1',
    settings: {
      tags: [],
      per: 20,
      image_ratio: ['16x9', '3x2', '4x3', '1x1', '3x4', '2x3', '9x16'],
      image_scaling: ['fit', 'fill']
    },
    customize: defaultCustomize,
    html:(
      <SudokuLayout {...props} />
    )
  }, {
    uid: 'collection-articles-2',
    settings: {
      tags: [],
      per: 20
    },
    customize: defaultCustomize,
    html:(
      <MediaLayout {...props} />
    )
  }, {
    uid: 'collection-articles-3',
    settings: {
      tags: [],
      per: 20
    },
    customize: defaultCustomize,
    html:(
      <JustTextLayout {...props} />
    )
  }, {
      uid: 'collection-articles-4',
      settings: {
        tags: [],
        per: 20
      },
      customize: defaultCustomize,
      html:(
        <BlogLayout {...props} />
      )
    }]
}

export default articlesCollection


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/collection/articles/index.js